import { DatePickerDesignTokens } from '@primeuix/themes/types/datepicker';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import componentColorScheme from '../one-ds-tokens/OneDS-Component-Color-Scheme.json';
import { t, tDeep, tNum } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/datepicker/index.ts
const dp = tDeep(componentCommon.datepicker);
const dpCs = componentColorScheme.datepicker;

export const DatePickerTelekomDT: DatePickerDesignTokens = {
  panel: {
    background: dp.panel.background,
    color: dp.panel.color,
    borderColor: dp.panel.border.color,
    borderRadius: dp.panel.border.radius,
    padding: dp.panel.padding,
  },
  header: {
    background: dp.header.background,
    color: dp.header.color,
    borderColor: dp.header.border.color,
    padding: `${dp.header.padding.top} ${dp.header.padding.right} ${dp.header.padding.bottom} ${dp.header.padding.left}`,
  },
  title: {
    gap: dp.title.gap,
    fontWeight: tNum(componentCommon.datepicker.title.font.weight),
  },
  dropdown: {
    width: dp.dropdown.width,
    sm: { width: dp.dropdown.sm.width },
    lg: { width: dp.dropdown.lg.width },
    borderColor: dp.dropdown.border.color,
    borderRadius: dp.dropdown.border.radius,
    hoverBorderColor: dp.dropdown.hover.border.color,
    activeBorderColor: dp.dropdown.active.border.color,
    focusRing: {
      width: dp.dropdown.focus.ring.width,
      color: dp.dropdown.focus.ring.color,
      offset: dp.dropdown.focus.ring.offset,
    },
    background: t(dpCs.dropdown.background),
    hoverBackground: t(dpCs.dropdown.hover.background),
    activeBackground: t(dpCs.dropdown.active.background),
    color: t(dpCs.dropdown.color),
    hoverColor: t(dpCs.dropdown.hover.color),
    activeColor: t(dpCs.dropdown.active.color),
  },
  inputIcon: {
    color: dp.input.icon.color,
  },
  selectMonth: {
    color: dp.select.month.color,
    hoverBackground: dp.select.month.hover.background,
    hoverColor: dp.select.month.hover.color,
    borderRadius: dp.select.month.border.radius,
    padding: `${dp.select.month.padding.y} ${dp.select.month.padding.x}`,
  },
  selectYear: {
    color: dp.select.year.color,
    hoverBackground: dp.select.year.hover.background,
    hoverColor: dp.select.year.hover.color,
    borderRadius: dp.select.year.border.radius,
    padding: `${dp.select.year.padding.y} ${dp.select.year.padding.x}`,
  },
  group: {
    borderColor: dp.group.border.color,
    gap: dp.group.gap,
  },
  dayView: {
    margin: `${dp.day.view.margin.top} ${dp.day.view.margin.right} ${dp.day.view.margin.bottom} ${dp.day.view.margin.left}`,
  },
  weekDay: {
    padding: dp.week.day.padding,
    fontWeight: tNum(componentCommon.datepicker.week.day.font.weight),
    color: dp.week.day.color,
  },
  date: {
    color: dp.date.color,
    hoverBackground: dp.date.hover.background,
    hoverColor: dp.date.hover.color,
    selectedBackground: dp.date.selected.background,
    selectedColor: dp.date.selected.color,
    rangeSelectedBackground: dp.date.range.selected.background,
    rangeSelectedColor: dp.date.range.selected.color,
    width: dp.date.width,
    height: dp.date.height,
    borderRadius: dp.date.border.radius,
    padding: dp.date.padding,
    focusRing: {
      width: dp.date.focus.ring.width,
      color: dp.date.focus.ring.color,
      offset: dp.date.focus.ring.offset,
    },
  },
  monthView: {
    margin: `${dp.month.view.margin.top} ${dp.month.view.margin.right} ${dp.month.view.margin.bottom} ${dp.month.view.margin.left}`,
  },
  month: {
    padding: dp.month.padding,
    borderRadius: dp.month.border.radius,
  },
  yearView: {
    margin: `${dp.year.view.margin.top} ${dp.year.view.margin.right} ${dp.year.view.margin.bottom} ${dp.year.view.margin.left}`,
  },
  year: {
    padding: dp.year.padding,
    borderRadius: dp.year.border.radius,
  },
  buttonbar: {
    borderColor: dp.buttonbar.border.color,
    padding: `${dp.buttonbar.padding.top} ${dp.buttonbar.padding.right} ${dp.buttonbar.padding.bottom} ${dp.buttonbar.padding.left}`,
  },
  timePicker: {
    borderColor: dp.time.picker.border.color,
    gap: dp.time.picker.gap,
    buttonGap: dp.time.picker.button.gap,
    padding: `${dp.time.picker.padding.top} ${dp.time.picker.padding.right} ${dp.time.picker.padding.bottom} ${dp.time.picker.padding.left}`,
  },
  today: {
    background: t(dpCs.today.background),
    color: t(dpCs.today.color),
  },
};
